import React, {useEffect, useRef} from "react";
import Api from "../../fetchs/Api";
import Modals from "../../componentesHTML/componentesSecundarios/Modals";
import {useStoreGlobal} from '../../../stores/Global'
import {useShallow} from 'zustand/react/shallow'
import Highlighter from "react-highlight-words"
import ApiInsertarBusquedaClic from "../../fetchs/ApiInsertarBusquedaClic";
import latinize from 'latinize';
import ApiInsertarBusqueda from "../../fetchs/ApiInsertarBusqueda";
function BuscadorNoticias(parametros){
  const _updateTotalDatos= useStoreGlobal(useShallow((state) => state._updateTotalDatos));
  const descripcionRef= useRef([]);
  let apiData = "";
  let var_ingles = "es";
  if (window.location.href.indexOf("en.") > -1) {
      var_ingles = "en";
  }
  let idioma = var_ingles==="es"?"Fecha de última actualización: ":"Date for last update: ";
  let idioma2 = var_ingles==="es"?"Fuente: ":"Source: ";
  const registradatos = ((TITULO,URL,metodoBusqueda) => {
    TITULO= TITULO.replace(/['°|@_=¿?¡~!:/<>()&%#*;+-.,?^${}[(\)]|[\]\\]/g, " ");
      let metodo="";
      if (metodoBusqueda === 1){
        metodo="Todas las palabras";
      }
      if (metodoBusqueda === 2){
        metodo="Cualquier palabra";
      }
      if (metodoBusqueda === 3){
        metodo="Frase completa";
      }
      const param = {
        CONTADOR_CLICK: 1,
        ID_COLECCION: "30",
        IP_USER: "",
        Metodo: metodo,
        Palabra_relacionada: "",
        TEXTO_BUSCADO: parametros.textoBusqueda,
        TITULO_URL: TITULO.replace(/['°|@_=¿?~¡!:/<>()&%#*;+-.,?^${}[(\)]|[\]\\]/g, " "),
        URL: URL
      };
    ApiInsertarBusquedaClic(param);
  });
  const highlightTexto = (textoSuggest) => {
        let campo = document.getElementById('inputQ').value.trim();
        campo= campo.replace(/['°|@_=¿?¡!:/<>~()&%#*;+-.,?^${}[(\)]|[\]\\]/g, " ");
        campo= trataTextoHigh(campo);
        let textInputAux = campo.split(" ");
        let concatena= [];
        for (const word of textInputAux) {
          concatena.push(`${word}`); 
        }
        return  (
            <Highlighter
                    highlightClassName="highlight"
                    searchWords={concatena}
                    autoEscape={true}
                    textToHighlight= {textoSuggest}
                    sanitize={sanitizeText}
                /> 
        );
    }
    const sanitizeText = (text) => {
      return latinize(text);
    };
    function trataTextoHigh(texto) { 
    let articulos = [
        "insert", "drop", "delete", "truncate", ";", "--", "xp_", "in", "table", "exec", "of", "with", "the", "from", "al", "as", "is", "can", " also ", " already ", " more ", " you ", " others ", " and ", " but ", " between ", " are ", " than ", "one", "no", "your", "it",
        "a", "e", "i", "o", "u", "adónde", "al", "algo", "alguien", "alguna", "algunas", "alguno", "algunos", "ante", "aquel", "aquél",
        "aquella", "aquélla", "aquellas", "aquéllas", "aquello", "aquellos", "aquéllos", "bajo", "cabe",
        "como", "cómo", "con", "conmigo", "consigo", "contigo", "contra", "cual", "cuál", "cuales", "cuáles",
        "cualesquiera", "cualquiera", "cuando", "cuándo", "cuanta", "cuánta", "cuantas", "cuántas", "cuánto",
        "cuantos", "cuántos", "cuya", "cuyas", "cuyo", "cuyos", "de", "del", "demás", "desde", "donde", "dónde",
        "durante", "el", "él", "ella", "ellas", "ello", "ellos", "en", "entre", "es", "esa", "ésa", "esas", "ésas", "ese",
        "ése", "eso", "esos", "ésos", "esotra", "esotro", "esta", "está", "ésta", "estas", "éstas", "este", "éste",
        "esto", "estos", "éstos", "hacia", "hasta", "la", "las", "le", "les", "lo", "los", "más", "me", "mediante",
        "mí", "mía", "mías", "mío", "míos", "misma", "mismas", "mismo", "mismos", "mucha", "muchas", "mucho",
        "muchos", "nada", "nadie", "ninguna", "ningunas", "ninguno", "ningunos", "no", "nos", "nosotras",
        "nosotros", "nuestra", "nuestras", "nuestro", "nuestros", "os", "otra", "otras", "otro", "otros",
        "para", "pero", "poca", "pocas", "poco", "pocos", "por", "puede", "que", "qué", "quien", "quién", "quienes", "quiénes",
        "se", "según", "sí", "sin", "so", "sobre", "son", "su", "suya", "suyas", "suyo", "suyos", "también", "tanta",
        "tantas", "tanto", "tantos", "te", "ti", "toda", "todas", "todo", "todos", "tras", "tú", "tuya", "tuyas", "tuyo",
        "tuyos", "última", "últimas", "último", "últimos", "un", "una", "unas", "uno", "unos", "usted", "ustedes", "varias",
        "varios", "versus", "vía", "vos", "vosotras", "vosotros", "vuestra", "vuestras", "vuestro", "vuestros", "y", "ya", "yo"
    ];
    let parrafo = (texto.replace(/\./g, '').trim());
    let palabras = parrafo.split(/\s/);
    for (let p = 0; p < palabras.length; p++) {
        for (let a = 0; a < articulos.length; a++) {
            if (articulos[a] == palabras[p].toLowerCase()) {
                palabras[p] = '';
                break;
            }
        }
    }
    let newTexto = palabras.join(' ');
    let textoTratado = newTexto.replace(/([\ \t]+(?=[\ \t])|^\s+|\s+$)/g, '');
    return textoTratado;
    }
    function formatoFecha(idioma, FECHA_PUBLICACION){
        let fe= FECHA_PUBLICACION.split("T");
        let fecha = idioma + fe[0];
        return fecha;
    }
if (parametros.coleccionTodo == "Todo"){
  let datos=parametros.datos;
  let id= parametros.id;
  let metodo= parametros.metodo;
  useEffect(() => { 
    if (datos.DESCRIPCION_NOTICIA !=="")
      document.getElementById("row_noticia-" + id).innerHTML=datos.DESCRIPCION_NOTICIA;
  }, [datos]);
  return(
      <div className = "col-xs-12 col-sm-12 todo" key={"coleccionBuscadorNoticias-" +id} style={{marginBottom:"26px"}} id={"resultadoGeneral-" + id}>
            <div className="col-xs-12 col-sm-12 col-lg-10" id={"titulo-" + id}>
              <a target="_blank" href={datos.URL} style={{display:"inline-flex"}} id={"TituloHip-" + id}> 
                <div  id={"gadget-" + id} onClick={() =>registradatos(datos.TITULO,datos.URL, metodo)}>
                  {highlightTexto(datos.TITULO)}
                </div>
              </a>
            </div>
            {
              datos.IMAGEN.indexOf("nada.gif") < 0 ? 
              <p className="text-justify" id={"snippet_row-tag-" + id} style={{paddingTop:"5px"}}>
                <img src={"https://inegi.org.mx/" + datos.IMAGEN} className="img-rounded img-responsive ie-responsive" align="left" id={"imagen-" + id} style={{margin:"0px 16px 5px 0px", width:"190px", height:"130px"}} alt="" />
              </p>
              : ""
            }
            <div className="col-md-11 col-lg-12 col-xs-12" style={{paddingLeft: "0px",paddingRight:"0px", display:"inline-flex"}} id={"nivel0-" + id}>
              <div className="col-md-10 col-xs-9" style={{marginTop:"10px", paddingLeft:"0px"}} id={"nivel0-1-" + id}>
                <p className="col-md-12 noticias_row" id={"row_fecha-" + id} style={{color:"rgb(136,136,136)", marginBottom:"5px"}} >{datos.FECHA_ACTUALIZADA}</p>
                <span className="col-md-12 noticias_row" id={"row_noticia-" + id}>
                </span>
              </div>
              <div className="col-md-2 col-xs-3" style={{marginTop:"10px", textAlignLast:"right"}}  id={"nivel1-1-" + id}>
                {
                  datos.BOLETIN_DOC !==""? 
                  <> 
                      <a className="noticias_row" target="_blank" href={datos.BOLETIN_DOC} id={"div_boletindoc-a-" + id} style={{textAlign:"right"}} onClick={() =>registradatos(datos.TITULO, datos.BOLETIN_DOC, metodo)}>
                        <img src="/img/ico/ico_doc.png" id={"div_boletindoc-imagen-" + id} alt=""/>
                      </a>
                      <div id={"div_boletindoc-span-" + id} >
                            <small> {datos.PESO_DOC + " MB"} </small>
                      </div>
                    </>
                  :"" 
                }
                {
                  datos.BOLETIN_PDF !==""? 
                  <>
                      <a className="noticias_row" target="_blank" href={datos.BOLETIN_PDF} id={"div_boletinpdf-a-" + id} style={{textAlign:"right"}} onClick={() =>registradatos(datos.TITULO,datos.BOLETIN_PDF, metodo)}>
                        <img src="/img/ico/ico_pdf.png"  id={"div_boletinpdf-imagen-" + id} alt=""/>
                      </a>
                      <div id={"div_boletinpdf-span-" + id} > 
                        <small> {datos.PESO_PDF + " MB"} </small>
                      </div>
                    </>
                  :"" 
                }
                {
                  datos.URL_VIDEO !==""? 
                    <a className="noticias_row" target="_blank" href={datos.URL_VIDEO} id={"div_video-a-" + id} onClick={() =>registradatos(datos.TITULO,datos.URL_VIDEO, metodo)}>
                      <div id={"div_urlvideo-" + id} style={{textAlign:"right"}}>
                        <img src="/img/ico/ico_youtube.png"  id={"div_video_imagen-" + id} alt=""/>
                      </div>
                    </a>
                  :""
                }
                {
                  datos.URL_SONIDO !==""? 
                  <a className="noticias_row" target="_blank" href={datos.URL_SONIDO} id={"div_sonido-a-" + id} onClick={() =>registradatos(datos.TITULO,datos.URL_SONIDO, metodo)} >
                    <div id={"div_urlsonido-" + id} style={{textAlign:"right"}}>
                      <img src="/img/ico/ico_audio.png" className="" id={"div_sonido_imagen-" + id} style={{fontSize:"1.8em"}}  alt=""/>
                    </div>
                  </a>
                  :""
                }
              </div>
            </div>
            {
              datos.BOLETIN_PDF !=="" && datos.BOLETIN_DOC !==""?
                <div className="col-12  interNoticias noticias_row formato_fecha" id={"row_fuente-" + id}>{idioma2 + datos.FUENTE}</div>
              :<div className="col-12  noticias_row formato_fecha" id={"row_fuente-" + id}>{idioma2 + datos.FUENTE}</div>
            }
            <div className="col-xs-12" id={"nivel3-" + id}>
              <div className="col-xs-12 formato_fecha"  id={"nivel3-1-" + id}>
                <span className="indLink" id={"fecha_actual-" + id}>  { 
                      formatoFecha(idioma, datos.FECHA_PUBLICACION)
                    }
                </span>
              </div>
            </div>
      </div>
  );
} 
else{
  let metodo="";
      if (parametros.metodoBusqueda === 1){
        metodo="Todas las palabras";
      }
      if (parametros.metodoBusqueda === 2){
        metodo="Cualquier palabra";
      }
      if (parametros.metodoBusqueda === 3){
        metodo="Frase completa";
      }
  const param = {
    busqueda: parametros.textoBusqueda,
    busquedaCiencia: "",
    paginaInicio: parametros.pageInicial,
    paginaFin: parametros.pageFin,
    idioma: var_ingles,
    filtrobusqueda: parametros.camposBuscador,
    orderby: parametros.camposOrden,
    orderbyAscDesc: parametros.ordenamiento,
    metodoBusqueda: parametros.metodoBusqueda
  };
  apiData = Api("/app/api/buscadorcore/v1/busquedaNoticias/", param)
  function RegistraBus(data){
    if(data.length > 0)
      ApiInsertarBusqueda(parametros.textoBusqueda ,"30", data[0].TOTAL, metodo);
    else
      ApiInsertarBusqueda(parametros.textoBusqueda ,"30", 0, metodo);
  }
  useEffect(() => {
    if(parametros.coleccionTodo != "Todo"){
      apiData.data.forEach(element => {
        if (descripcionRef.current[element.ID] != null ) {
          document.getElementById("row_noticia-" + element.ID).innerHTML=element.DESCRIPCION_NOTICIA;
        }
      });
      if (!apiData.loading){
          RegistraBus(apiData.data)
        }
      if(apiData.data.length > 0) {
        document.getElementById('resultados').innerHTML= apiData.data[0].TOTAL;
        _updateTotalDatos({totalDatos:apiData.data[0].TOTAL});
      }else{
        _updateTotalDatos({totalDatos:0});
      }
    }
  },[apiData.data]);
  return(
      <>
      {apiData.loading? <Modals />:
        !apiData.loading && apiData.data?.map((datos,i) => (
        <div className = "col-xs-12 col-sm-12 todo" key={"coleccionBuscadorNoticias-" + i} style={{marginBottom:"26px"}} id={"resultadoGeneral-" + i}>
              <div className="col-xs-12 col-sm-12 col-lg-10" id={"titulo-" + i}>
                <a target="_blank" href={datos.URL} style={{display:"inline-flex"}} id={"TituloHip-" + i}> 
                  <div  id={"gadget-" + i} onClick={() =>registradatos(datos.TITULO,datos.URL,parametros.metodoBusqueda)}>
                    {highlightTexto(datos.TITULO)}
                  </div>
                </a>
              </div>
              {
                datos.IMAGEN.indexOf("nada.gif") < 0 ? 
                <p className="text-justify" id={"snippet_row-tag-" + i} style={{paddingTop:"5px"}}>
                  <img src={"https://inegi.org.mx/" + datos.IMAGEN} className="img-rounded img-responsive ie-responsive" align="left" id={"imagen-" + i} style={{margin:"0px 16px 5px 0px", width:"190px", height:"130px"}} alt="" />
                </p>
                : ""
              }
              <div className="col-md-11 col-lg-12 col-xs-12" style={{paddingLeft: "0px",paddingRight:"0px", display:"inline-flex"}} id={"nivel0-" + i}>
                <div className="col-md-10 col-xs-9" style={{marginTop:"10px", paddingLeft:"0px"}} id={"nivel0-1-" + i}>
                  <p className="col-md-12 noticias_row" id={"row_fecha-" + i} style={{color:"rgb(136,136,136)", marginBottom:"5px"}} >{datos.FECHA_ACTUALIZADA}</p>
                  <span className="col-md-12 noticias_row" id={"row_noticia-" + i} ref={(el) => (descripcionRef.current[i] = el)}>
                  </span>
                </div>
                <div className="col-md-2 col-xs-3" style={{marginTop:"10px", textAlignLast:"right"}}  id={"nivel1-1-" + i}>
                  {
                    datos.BOLETIN_DOC !==""? 
                    <> 
                      <a className="noticias_row" target="_blank" href={datos.BOLETIN_DOC} id={"div_boletindoc-a-" + i} style={{textAlign:"right"}} onClick={() =>registradatos(datos.TITULO, datos.BOLETIN_DOC, parametros.metodoBusqueda)}>
                        <img src="/img/ico/ico_doc.png" id={"div_boletindoc-imagen-" + i} alt=""/>
                      </a>
                      <div id={"div_boletindoc-span-" + i} >
                            <small> {datos.PESO_DOC + " MB"} </small>
                      </div>
                    </>
                    :"" 
                  }
                  {
                    datos.BOLETIN_PDF !==""? 
                    <>
                      <a className="noticias_row" target="_blank" href={datos.BOLETIN_PDF} id={"div_boletinpdf-a-" + i} style={{textAlign:"right"}} onClick={() =>registradatos(datos.TITULO,datos.BOLETIN_PDF,parametros.metodoBusqueda)}>
                        <img src="/img/ico/ico_pdf.png"  id={"div_boletinpdf-imagen-" + i} alt=""/>
                      </a>
                      <div id={"div_boletinpdf-span-" + i} > 
                            <small> {datos.PESO_PDF + " MB"} </small>
                      </div>
                    </>
                    :"" 
                  }
                  {
                    datos.URL_VIDEO !==""? 
                      <a className="noticias_row" target="_blank" href={datos.URL_VIDEO} id={"div_video-a-" + i} onClick={() =>registradatos(datos.TITULO,datos.URL_VIDEO,parametros.metodoBusqueda)}>
                        <div id={"div_urlvideo-" + i} style={{textAlign:"right"}}>
                          <img src="/img/ico/ico_youtube.png"  id={"div_video_imagen-" + i} alt=""/>
                        </div>
                      </a>
                    :""
                  }
                  {
                    datos.URL_SONIDO !==""? 
                    <a className="noticias_row" target="_blank" href={datos.URL_SONIDO} id={"div_sonido-a-" + i} onClick={() =>registradatos(datos.TITULO,datos.URL_SONIDO,parametros.metodoBusqueda)} >
                      <div id={"div_urlsonido-" + i} style={{textAlign:"right"}}>
                        <img src="/img/ico/ico_audio.png" className="" id={"div_sonido_imagen-" + i} style={{fontSize:"1.8em"}}  alt=""/>
                      </div>
                    </a>
                    :""
                  }
                </div>
              </div>
              {/* <div className="col-12 interNoticias noticias_row formato_fecha" id={"row_fuente-" + i}>{idioma2 + datos.FUENTE}</div> */}
                {
                  datos.BOLETIN_PDF !=="" && datos.BOLETIN_DOC !==""?
                    <div className="col-12  interNoticias noticias_row formato_fecha" id={"row_fuente-" + i}>{idioma2 + datos.FUENTE}</div>
                  :<div className="col-12  noticias_row formato_fecha" id={"row_fuente-" + i}>{idioma2 + datos.FUENTE}</div>
                }
              <div className="col-xs-12" id={"nivel3-" + i}>
                <div className="col-xs-12 formato_fecha"  id={"nivel3-1-" + i}>
                  <span className="indLink" id={"fecha_actual-" + i}> { 
                      formatoFecha(idioma, datos.FECHA_PUBLICACION)
                    }
                  </span>
                </div>
              </div>
        </div>
        ))
      }
      </>
  );
}

}
export default BuscadorNoticias;